// DeltaSwitch.tsx update
import React, { useState, useEffect } from 'react';

interface DeltaSwitchProps {
    labels: string[];
    id?: string;
    defaultSelectedIndex?: number;
    onSelectionChange?: (selectedLabel: string) => void;
}

const DeltaSwitch: React.FC<DeltaSwitchProps> = ({ 
    labels, 
    id,
    defaultSelectedIndex = 0, 
    onSelectionChange 
}) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(defaultSelectedIndex);

    // Update when default selection changes
    useEffect(() => {
        setSelectedIndex(defaultSelectedIndex);
    }, [defaultSelectedIndex]);

    const handleButtonClick = (index: number) => {
        setSelectedIndex(index);
        
        // Notify parent component about the change
        if (onSelectionChange) {
            onSelectionChange(labels[index]);
        }
    };

    return (
        <div id={id} className={`tw-flex tw-rounded tw-bg-[#7676801F] tw-p-0.5`}>
            {labels.map((label, index) => (
                <React.Fragment key={index + label}>
                    <div className={`tw-flex tw-gap-2 tw-p-0.5 tw-h-9`}>
                    {index !== 0 && (
                        <span className={`tw-self-center tw-w-[1px] tw-h-[12px] tw-mb-2.5 tw-text-[#dedee2] tw-transition-opacity tw-duration-300 tw-ease-in-out tw-opacity-100`}>|</span>
                    )}
                    <button
                        className={`tw-self-stretch tw-py-2.5 tw-px-[12px]  ${
                            index === selectedIndex
                                ? ' tw-rounded-10xs tw-bg-white tw-shadow-[0px_3px_8px_rgba(0,_0,_0,_0.12),_0px_3px_1px_rgba(0,_0,_0,_0.04)] tw-flex tw-flex-row tw-items-center tw-justify-center tw-text-[#093BCD] tw-border-gray-400'
                                : ' tw-flex tw-flex-row tw-items-center tw-justify-center'
                        }  tw-rounded tw-transition-all tw-duration-300 tw-ease-in-out`}
                        onClick={() => handleButtonClick(index)}
                    >
                        {label}
                    </button>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
};

export default DeltaSwitch;